angular.module('cn')
.component('cnList', {
  template: require('./cnlist.html'),
  bindings: {
    networks: '<',
    search: '<'
  }
});



// WEBPACK FOOTER //
// ./src/cn/cnlist.js